import { render, staticRenderFns } from "./left-fourth.vue?vue&type=template&id=a2a663ea&scoped=true&"
import script from "./left-fourth.vue?vue&type=script&lang=js&"
export * from "./left-fourth.vue?vue&type=script&lang=js&"
import style0 from "./left-fourth.vue?vue&type=style&index=0&id=a2a663ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a663ea",
  null
  
)

export default component.exports